"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.name");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var platform = require("platform");

var Metadata =
/*#__PURE__*/
function () {
  function Metadata() {
    _classCallCheck(this, Metadata);
  }

  _createClass(Metadata, null, [{
    key: "getMetadata",
    value: function getMetadata(options) {
      var platformInfo = typeof navigator !== 'undefined' ? platform.parse(navigator.userAgent) : platform;
      var overrides = options && options.clientMetadata ? options.clientMetadata : {};
      var fieldNames = ['ver', 'env', 'envv', 'os', 'osv', 'osa', 'type', 'sdk', 'sdkv', 'dev', 'devv', 'devt', 'app', 'appv'];
      var defaults = {
        'env': platform.name,
        'envv': platform.version,
        'os': platform.os.family,
        'osv': platform.os.version,
        'osa': platform.os.architecture,
        'sdk': 'js-default'
      };
      var finalClientMetadata = {};
      fieldNames.filter(function (key) {
        return key in overrides || key in defaults;
      }).forEach(function (key) {
        return finalClientMetadata[key] = key in overrides ? overrides[key] : defaults[key];
      });
      return finalClientMetadata;
    }
  }]);

  return Metadata;
}();

exports.Metadata = Metadata;